import { render } from "./SupportOld2024Main.vue?vue&type=template&id=3cd2d87e"
import script from "./SupportOld2024Main.vue?vue&type=script&lang=js"
export * from "./SupportOld2024Main.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__